import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Redirect } from 'react-router-dom';
import renderHTML from 'react-render-html';
import { Fade } from 'react-reveal';
import { Actions } from '../../../flux';
import { images, texts, relacionamentos } from '../../../settings';
import { DelayLink, SliderText } from '../../../components';

import '../Iniciativas.scss';
import './DataFundos.scss';

class DataFundos extends Component {
  constructor(props) {
		super(props);

    this.contentText = React.createRef();
  }

  scrollTop = () => {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  }

  componentDidMount = () => {
    Actions.headerIntern();
		this.scrollTop();
  }

  render = () => {
    return (
      <div className="views" ref={this.contentText}>
				<Helmet>
					<title>Data Fundos - Iniciativas - {texts.title}</title>
				</Helmet>


				<div className="iniciativas-home data-fundos-home bg-gray" ref="data-fundos-home">

					<section className="iniciativas-area page--yellow">
						<div className="container container--large">
							<div className="row">
								<div className="col-12">
									<Fade bottom>
										<div className={`card card--page-body card--yellow`}>
											<div className="card__content">
												<div className="card__content__header">
													<DelayLink to={`/estrategias/para-o-mercado`} className="button button--aylen button--gray-500 button--border-medium button--size-m button--round-l button--text-thick">
														Voltar
													</DelayLink>
													<h1 className="title title--gray">
														<span className="gri_text gri_text--fixed">
															ANBIMA Data Fundos
															<span className="gri_label gray">GRI <b>203-1 </b></span>
														</span>
													</h1>
												</div>
												<div className="card__content__body">
													<p>Agora é possível encontrar informações sobre fundos de investimento no ANBIMA Data. A plataforma gratuita, lançada em 2018 com documentos de debêntures, foi ampliada para dar transparência à indústria e ajudar a fomentar os negócios a partir da disponibilização de dados comparáveis e de qualidade.</p>
													<p>A novidade beneficiou, principalmente, os distribuidores que utilizavam diferentes bases para compor as informações de um fundo – no sistema, eles encontram tudo em um único lugar.</p>
												</div>
											</div>
											
											{/* <div className="card__image">
												<img src={content.image} />
											</div> */}
										</div>
									</Fade>
								</div>
							</div>
						</div>
					</section>

					<section className="iniciativas-body">

						<div className="container container--large">
							<div className="row">
								
								<div className="col-12">
									<Fade bottom>
										<div className="card card--no-border card--horas">
											<div className="card__content card__content--full">

												<div className="card__content__body">
													<p className="yellow"><strong>Com registro dos mais de 17 mil fundos regulados pela Instrução CVM 555, o ANBIMA Data disponibiliza diariamente:</strong></p>

													<ul className="bullets bullets--yellow">
														<li>Dados cadastrais, CNPJ, classe ANBIMA, nome etc.;</li>
														<li>Lista dos prestadores de serviços de cada fundo: administrador, distribuidor, gestor, entre outros;</li>
														<li>Taxas, como administração e performance, quando for o caso;</li>
														<li>Movimentações das cotas: valor mínimo para aplicação, prazo para resgate, valor mínimo para novos aportes etc.;</li>
														<li>Série histórica, como patrimônio líquido, captação e número de cotistas do último ano;</li>
														<li>Regulamento do fundo.</li>
													</ul>
												</div>

											</div>
										</div>
									</Fade>
								</div>
								
								{/* <div className="col-6">
									<Fade bottom>
										<div className="card card--no-border">
											<div className="card__content card__content--full">

												<div className="card__content__body">
													<img src={images.para_o_mercado.grafico_fundos} className="grafico_fundos" />
												</div>

											</div>
										</div>
									</Fade>
								</div> */}

							</div>
						</div>

						<div className="container container--large">
							<div className="row">
								
								<div className="col-12">
									<Fade>
										<div className="card card--no-border card--footer">
											<div className="card__content card__content--full">

												<div className="card__content__body">
													<img src={images.icons.globe_yellow} />
													<p>O acesso pode ser feito pelo site <a href="http://data.anbima.com.br" target="_blank" className="text_link text_link--yellow text_link--no-underline">data.anbima.com.br</a>   ou a partir da integração do ANBIMA Data em outro sistema por meio do <a href="https://www.anbima.com.br/pt_br/produtos-servicos/anbima-feed/anbima-feed.htm" target="_blank" className="text_link text_link--yellow text_link--no-underline">ANBIMA Feed</a>, nossa plataforma de APIs (Aplicação de Interface de Programas).</p>
												</div>

											</div>
										</div>
									</Fade>
								</div>

							</div>
						</div>

					</section>

				</div>

      </div>
    );
  }
}

export { DataFundos };
